module.exports = __webpack_public_path__ + "static/images/components/ButtonTiny/images/secondary-borders-hover.9ec5f568.png";


//////////////////
// WEBPACK FOOTER
// ./components/ButtonTiny/images/secondary-borders-hover.png
// module id = 2583
// module chunks = 11